/**
 * viewmodel导出对象
 * 供view和controller导入
 */
import TrendTurnoverState from './trendturnover'; // 分时成交量
import TrendFiveTurnoverState from './trendfiveturnover'; // 五日成交量
import TrendState from './trend'; // 分时日线
import TrendLineState from './trend/trendline'; // 分时折线
import TrendJQJZDectorator from './dectorator/trendjqjzdectorator'; // 分时鲸奇9转装饰器
import TrendFiveState from './trendfive'; // 五日分时
import MACDState from './macd'; // 分时MACD
import TrendCapitalState from './trendcapital'; // 分时资金博弈
import TrendFundflowState from './trendfundflow'; // 分时资金流向
import KLineState from './kline'; // K线
import KLineTurnoverState from './klineturnover'; // K线成交量
import KLineKDJState from './klinekdj'; // K线KDJ
import KLineENEState from './klineene'; // K线ENE
import KLineElectricState from './electric'; // 晓鲸电波
import KLineMADectorator from './dectorator/klineavgdectorator'; // K线均线图装饰器
import KLineBOLLDectorator from './dectorator/klinebolldectorator'; // K线BOLL装饰器
import KLineKDDectorator from './dectorator/klinekddectorator'; // K线KD密码图装饰器
import KLineJQJZDectorator from './dectorator/klinejqjzdectorator'; // K线鲸奇9转装饰器
import RSIState from './rsi' //rsi指标
import DMAState from './dma';
import VRState from './vr'
import WRState from './wr'
import OBVState from './obv'
import DMIState from './dmi'
import PSYState from './psy'
import LIANGBIState from './liangbi'
// import KLineSwanDectorator from './dectorator/klineswandectorator'; // K线鸿鹄震荡装饰器
// /**** 折线图类型 ****/
// const LINE = Symbol('折线');
// const GRIDENT = Symbol('折线渐变');
// const LINE_TYPE = { LINE, GRIDENT };
/**** 错误信息 ****/
// const ERROR_TEXT = Symbol('暂无数据');
// const ERROR_IMAGE = Symbol('暂无数据图片');
// const ERROR_TYPE = { ERROR_TEXT, ERROR_IMAGE };
/**** 请求状态 ****/
const LOADING = Symbol('正在加载');
const ERROR = Symbol('加载出错');
const LOADED = Symbol('加载完成');
const NET_STATUS = { LOADING, ERROR, LOADED };
/**** 分时五档明细 ****/
const TREND_WD = Symbol('五档');
const TREND_MX = Symbol('明细');
const TREND_CJ = Symbol('成交');
const TREND_TYPE = { TREND_WD, TREND_MX, TREND_CJ };
/**** 更新区域 ****/
const MAIN_AREA = Symbol('主视图');
const FOOT_AREA = Symbol('辅视图');
/**** 组件状态 ****/
const TREND_ONE = 10;//分时
const TREND_FIVE = 11;//五日
const KLINE_ONEMIN = 1;//一分钟
const KLINE_FIVEMIN = 2;//5分钟
const KLINE_FIFMIN = 3;//15分钟
const KLINE_THIMIN = 4;//30分钟
const KLINE_SIXMIN = 5;//60分钟
const KLINE_ONEDAY = 6;//一天
const KLINE_ONEWEEK = 7;//一周
const KLINE_ONEMONTH = 8;//一个月
const KLINE_ONEYEAR = 9;//一年
/**** 除复权状态 ****/
const KLINE_NONE = 0; // 除权
const KLINE_BEFORE = 1; // 前复权
const KLINE_AFTER = 2; // 后复权
const KLINE_TYPE = { KLINE_NONE, KLINE_BEFORE, KLINE_AFTER };
/**** k线图类型 ****/
const KLINE = 0; // 基本k线
const KLINE_US = 11; // 美国线
const KLINE_LINE = 12; // 收盘价折线
const KLINE_AREA = 13; // 收盘价面积线
const KLINE_MAP_TYPE = { KLINE, KLINE_US, KLINE_LINE, KLINE_AREA }
/**** 外汇价格k线类型 ****/
const TRADING_PRICE = '1';//成交价
const GOOD_BUY_PRICE = '2.2';//最优买价
const GOOD_SELL_PRICE = '2.3';//最优卖价
const END_PRICE = '1.0';//14:30收盘价
const CENTER_PRICE = '3';//中间价
const KLINE_PRICE_TYPE = { TRADING_PRICE,GOOD_BUY_PRICE,GOOD_SELL_PRICE,END_PRICE,CENTER_PRICE };
/**** MA5,MA10,MA20,MA30,MA60,MA60 ****/
const KLINE_MA5 = 5;
const KLINE_MA10 = 10;
const KLINE_MA20 = 20;
const KLINE_MA30 = 30;
const KLINE_MA60 = 60;
const KLINE_MA120 = 120;
const KLINE_MATYPE = { KLINE_MA5, KLINE_MA10, KLINE_MA20, KLINE_MA30, KLINE_MA60, KLINE_MA120 };
/**** 组件各部分的状态映射 ****/
/**** 辅视图状态 ****/
const AMOUNT_KEY = 1;
const MACD_KEY = 2;
const KDJ_KEY = 4;
const ENE_KEY = 8;
const ELECTRIC_KEY = 16;
const FUNDFLOW_KEY = 32;
const FUNDFLOWDIR_KEY = 64;
const DMA_KEY = 128;
const VR_KEY = 256;
const WR_KEY = 512;
const OBV_KEY = 1024;
const DMI_KEY = 2048;
const RSI_KEY = 4096;
const PSY_KEY = 8192;
const LIANGBI_KEY = 16384;
// 添加noauth，以便vue收集依赖绑定
// k线的
const FOOT_KLINE = [
  { key: AMOUNT_KEY, context: KLineTurnoverState, text: '成交量', noauth: true },
  { key: MACD_KEY, context: MACDState, text: 'MACD', noauth: true },
  { key: RSI_KEY, context: RSIState, text: 'RSI', noauth: true },
  { key: PSY_KEY, context: PSYState, text: "PSY", noauth: true },
  { key: DMI_KEY, context: DMIState, text: 'DMI', noauth: true },
  { key: OBV_KEY, context: OBVState, text: 'OBV', noauth: true },
  // { key: VR_KEY, context: VRState, text: 'VR', noauth: true },
  { key: WR_KEY, context: WRState, text: 'WR', noauth: true },
  // { key: DMA_KEY, context: DMAState, text: 'DMA', noauth: true },
  { key: KDJ_KEY, context: KLineKDJState, text: 'KDJ', noauth: true },
  { key: ENE_KEY, context: KLineENEState, text: 'ENE', noauth: true },
];
// 一天k线
const FOOT_KLINE_ONEDAY = [
  { key: MACD_KEY, context: MACDState, text: 'MACD', noauth: true },
  { key: DMI_KEY, context: DMIState, text: "DMI", noauth: true },
  { key: OBV_KEY, context: OBVState, text: "OBV", noauth: true },
  // { key: VR_KEY, context: VRState, text: 'VR', noauth: true },
  // { key: DMA_KEY, context: DMAState, text: 'DMA', noauth: true },
  { key: AMOUNT_KEY, context: KLineTurnoverState, text: '成交量', noauth: true },
  // { key: ELECTRIC_KEY, context: KLineElectricState, text: '电波', noauth: true },

  { key: PSY_KEY, context: PSYState, text: "PSY", noauth: true },
  { key: RSI_KEY, context: RSIState, text: 'RSI', noauth: true },
  { key: WR_KEY, context: WRState, text: 'WR', noauth: true },
  { key: KDJ_KEY, context: KLineKDJState, text: 'KDJ', noauth: true },
  { key: ENE_KEY, context: KLineENEState, text: 'ENE', noauth: true },
]
// 分时要展示的
const FOOT_STATUS = {
  [TREND_ONE]: [
    { key: MACD_KEY, context: MACDState, text: 'MACD', noauth: true },
    { key: DMI_KEY, context: DMIState, text: 'DMI', noauth: true },
    // { key: OBV_KEY, context: OBVState, text: 'OBV', noauth: true },
    // { key: WR_KEY, context: WRState, text: 'WR', noauth: true },
    { key: LIANGBI_KEY, context: LIANGBIState, text: 'LIANGBI', noauth: true },
    { key: VR_KEY, context: VRState, text: 'VR', noauth: true },
    { key: DMA_KEY, context: DMAState, text: 'DMA', noauth: true },
    { key: AMOUNT_KEY, context: TrendTurnoverState, text: '成交量', noauth: true },
    { key: FUNDFLOW_KEY, context: TrendCapitalState, text: '资金博弈', noauth: true },
    { key: FUNDFLOWDIR_KEY, context: TrendFundflowState, text: '资金流向', noauth: true },

    { key: PSY_KEY, context: PSYState, text: "PSY", noauth: true },
    { key: RSI_KEY, context: RSIState, text: 'RSI', noauth: true },
  ],
  // 五日的
  [TREND_FIVE]: [{ key: AMOUNT_KEY, context: TrendFiveTurnoverState, text: '成交量', noauth: true }],
  [KLINE_ONEMIN]: FOOT_KLINE,//k线的
  [KLINE_FIVEMIN]: FOOT_KLINE,//k线的
  [KLINE_FIFMIN]: FOOT_KLINE,//k线的
  [KLINE_THIMIN]: FOOT_KLINE,//k线的
  [KLINE_SIXMIN]: FOOT_KLINE,//k线的
  [KLINE_ONEDAY]: FOOT_KLINE_ONEDAY,//一日k线
  [KLINE_ONEWEEK]: FOOT_KLINE,
  [KLINE_ONEMONTH]: FOOT_KLINE,
  [KLINE_ONEYEAR]: FOOT_KLINE,
};
/**** 主视图状态 ****/
const TREND_KEY = 1;
const MA_KEY = 2;
const JZ_KEY = 4;
const KD_KEY = 8;
const HH_KEY = 16; // 鸿鹄震荡视图Key
const BOLL_KEY = 32; // BOLL线key
const AREA_KEY = 64;
const MAIN_KLINE = [
  { key: MA_KEY, context: KLineMADectorator(KLineState), text: 'average', noauth: true },
  { key: JZ_KEY, context: KLineJQJZDectorator(KLineState), text: '鲸奇9转', noauth: true },
  // { key: KD_KEY, context: KLineKDDectorator(KLineState), text: 'KD密码', noauth: true },
  { key: BOLL_KEY, context: KLineBOLLDectorator(KLineState), text: 'BOLL', noauth: true }
  // {key: HH_KEY, context: KLineSwanDectorator(KLineState), text: '鸿鹄震荡', noauth: true},
];
const MAIN_STATUS = {
  [TREND_ONE]: [
    { key: TREND_KEY, context: TrendState, text: '分时', noauth: true },
    { key: JZ_KEY, context: TrendJQJZDectorator(TrendState), text: '鲸奇9转', noauth: true },
    { key: AREA_KEY, context: TrendLineState, text: 'broken line', noauth: true }
  ],
  [TREND_FIVE]: [{ key: TREND_KEY, context: TrendFiveState, text: '五日分时', noauth: true }],
  [KLINE_ONEMIN]: MAIN_KLINE,
  [KLINE_FIVEMIN]: MAIN_KLINE,
  [KLINE_FIFMIN]: MAIN_KLINE,
  [KLINE_THIMIN]: MAIN_KLINE,
  [KLINE_SIXMIN]: MAIN_KLINE,
  [KLINE_ONEDAY]: MAIN_KLINE,
  [KLINE_ONEWEEK]: MAIN_KLINE,
  [KLINE_ONEMONTH]: MAIN_KLINE,
  [KLINE_ONEYEAR]: MAIN_KLINE
};
/**
 * [KEY_MAP 用于管理各视图的功能状态]
 * @type {Object}
 */
const KEY_MAP = {
  TREND_KEY,
  MA_KEY,
  JZ_KEY,
  KD_KEY,
  HH_KEY,
  BOLL_KEY,
  AREA_KEY,
  AMOUNT_KEY,
  MACD_KEY,
  PSY_KEY,
  RSI_KEY,
  DMI_KEY,
  OBV_KEY,
  WR_KEY,
  VR_KEY,
  DMA_KEY,
  LIANGBI_KEY,
  KDJ_KEY,
  ENE_KEY,
  ELECTRIC_KEY,
  FUNDFLOW_KEY,
  FUNDFLOWDIR_KEY,
};

// 深拷贝至dataManager，确保各个实例之间独立
export {
  TREND_ONE,
  TREND_FIVE,
  KLINE_ONEMIN,
  KLINE_FIVEMIN,
  KLINE_FIFMIN,
  KLINE_THIMIN,
  KLINE_SIXMIN,
  KLINE_ONEDAY,
  KLINE_ONEWEEK,
  KLINE_ONEMONTH,
  KLINE_ONEYEAR,

  // LINE_TYPE,
  // ERROR_TYPE,
  TREND_TYPE,
  KLINE_TYPE,
  KLINE_MAP_TYPE,
  KLINE_PRICE_TYPE,
  KLINE_MATYPE,
  NET_STATUS,

  KEY_MAP,
  MAIN_AREA,
  FOOT_AREA,
  MAIN_STATUS,
  FOOT_STATUS,
};
